module.exports = __webpack_public_path__ + "img/组 126@2x(2).7dc84d0c.png";